@import 'styles/variables';
@import 'styles/mixins';

.headerContainer {
  @include for-small-desktop-up {
    @include xl-semibold;

    display: flex;
    align-items: center;

    header {
      flex: 1;
    }
  }
}

.fixedContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 32px;
  padding-top: 20px;
}

.subtitleWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.subtitle {
  @include md-semibold;
  @include smooth-font-rendering;
}

.propertiesText {
  @include md-regular;
  @include smooth-font-rendering;

  color: var(--neutral-50);
}

.table {
  width: 100%;

  td,
  th {
    > div {
      display: flex;
      align-items: center;
    }
  }

  th {
    @include sm-regular;
    @include smooth-font-rendering;

    color: var(--neutral-30);
    cursor: pointer;
    text-align: left;
    padding: 2px 8px;

    svg {
      fill: var(--neutral-40);
      margin-left: 5px;
      min-width: 16px;
    }

    &.selected {
      color: var(--neutral-90);
    }

    &.actionColumn {
      width: 76px;
    }
  }

  th:nth-child(4) {
    padding: 2px 4px;
  }

  td {
    @include md-regular;
    @include smooth-font-rendering;
    padding: 6px 8px;
    color: var(--neutral-90);

    &.actionColumn {
      display: flex;
      padding: 4px;
      gap: 4px;
    }

    svg {
      path {
        color: var(--neutral-90);
      }
    }
  }

  th:first-child,
  td:first-child {
    width: 343px;
  }

  th:nth-child(2),
  td:nth-child(2) {
    min-width: 240px;
  }

  td:nth-child(2) {
    color: var(--neutral-50);
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 146px;

    > div {
      justify-content: center;
    }

    button {
      opacity: 0;
    }
  }

  tbody {
    tr {
      .actionIcon {
        visibility: hidden;
      }

      &:hover {
        background: $gray-5;
        cursor: default;

        .actionIcon {
          visibility: visible;
        }

        button {
          opacity: 1 !important;
        }
      }

      &.newButton:hover {
        cursor: pointer;
      }
    }
  }

  .dragger {
    &:hover {
      cursor: grab;
    }

    svg {
      fill: $navy-90;
      height: 16px;
      margin-top: 4px;
    }
  }

  .tableHeaderRow,
  .propertyRow {
    border-bottom: 1px solid var(--neutral-5);
  }
}

.sortIcon {
  fill: #000;
}

.newButton {
  @include md-regular;

  display: flex;
  align-items: center;
  color: var(--neutral-30);
  padding: 6px 10px 6px 6px;
  margin-top: 4px;
  margin-bottom: 4px;
  gap: 4px;

  .iconWrapper {
    display: flex;
    padding: 8px 0px;
  }

  svg {
    display: flex;
    align-self: center;
  }
}

.modalWrapper {
  // override min-width of modal component
  min-width: 320px;
  max-width: 320px;
}

.modalBody {
  padding: 8px !important;
}

.containedClick {
  max-width: 16px;
}

@include for-phone-only {
  .table {
    th:nth-child(2),
    td:nth-child(2) {
      min-width: 140px;
    }
    tbody {
      tr {
        .actionIcon {
          visibility: initial;
        }
      }
    }
    td.actionColumn {
      display: table-cell;
      min-width: 90px;
    }
  }
}

@include for-medium-phone-only {
  .table {
    th:nth-child(2),
    td:nth-child(2) {
      min-width: 120px;
    }
  }
}
